<div class="form_group search_bar">
  <mat-form-field class="srch" appearance="fill">
    <input
      #search
      matInput
      [placeholder]="placeholdertext"
      class="form_control" />
  </mat-form-field>

  <button
    mat-button
    matPrefix
    mat-icon-button
    class="btnn btn_primary"
    *ngIf="type === 'button'">
    <figure *ngIf="!showCrossIcon">
      <img src="{{ assetsConst.SearchIcon2 }}" alt="searchIcon" />
    </figure>
    Search Tutor
    <mat-icon *ngIf="showCrossIcon" (click)="clearInputField()">close</mat-icon>
  </button>

    <!-- <button
    mat-button
    matPrefix
    mat-icon-button
    class="btn_icon"
    *ngIf="type === 'home'">
    <figure *ngIf="!showCrossIcon">
      <img src="{{ assetsConst.SearchIcon2 }}" alt="searchIcon" />
    </figure>
  
    <mat-icon *ngIf="showCrossIcon" (click)="clearInputField()">close</mat-icon>
  </button> -->
  
</div>
